import styled from 'styled-components/macro';

import { colors } from '../../styles/vars';

const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 30px);
  font-size: 14px;
  color: ${props => (props.hover ? colors['black-six'] : colors['warm-grey-two'])};
`;

export default Item;
